import api from '../provider/fetchClient'

export const sendEmail = email => api.post('/email', email)
